import $ from 'jquery';
import config from './../../../../config';

export function request_leave( data ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'SAVE_LEAVE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_LEAVE",
				leave: response
			})
		})

    }
}

// Upload attachment
export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'leave/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_ATTACHMENT",
				leave: response
			})
		})

	}

}

export function get_leave_type( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
                method: 'GET_LEAVE_TYPE'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_TYPE",
				leave: response
			})
		})

	}
}

export function get_leave_by_id( id ){
    return dispatch => {

        $.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'GET_LEAVE_BY_ID',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_BY_ID",
				leave: response
			})
		})

    }
}



// WEBPACK FOOTER //
// ./src/pages/requests/leave/actions/leave.action.js